/**
 * Kintone 疎通確認 API の URL を導出する。
 *
 * BASE_PATH_V3 は `.../endpoint/v1/bff/carepro-id` までを含むが、
 * ヘルスチェックの実際のマウントパスは `/carepro-id` 配下ではなく
 * `/v1/bff/kintone/health/connectivity` にある（0006 の契約）。
 * 単純連結すると `/v1/bff/carepro-id/kintone/...` になり届かないため、
 * 末尾の `/carepro-id`（末尾スラッシュの有無を問わない）を取り除いてから連結する。
 *
 * 0006 のマウントパスが変わっても直すのはこの 1 ファイルだけになるよう、
 * 導出ロジックをここに閉じ込める。
 */
export function buildKintoneHealthUrl(basePathV3: string): string {
  const base = basePathV3 || ''
  const trimmed = base.replace(/\/carepro-id\/?$/, '')
  return `${trimmed}/kintone/health/connectivity`
}
